import React from "react";
import { connect } from "react-redux";

// CSS
import "../css/notices.css";

class Notices extends React.PureComponent {
	render() {
		let notice = null;

		if (this.props.notice) {
			if (this.props.notice.url) {
				notice = (
					<a className="notice_section" href={this.props.notice.url}>
						<div className="body_container">
							{this.props.notice.title}
							<span>click for more details</span>
						</div>
					</a>
				);
			} else {
				notice = (
					<div className="notice_section">
						<div className="body_container">{this.props.notice.title}</div>
					</div>
				);
			}
		}

		return notice;
	}
}

function mapStateToProps(state) {
	return {
		notice: state.siteInfo.notice
	};
}

export default connect(mapStateToProps)(Notices);



// WEBPACK FOOTER //
// ./src/components/Notices.js